import React from "react";

const ReachUs = () => {
  const socialLinks = [
    // { src: "/icon-facebook.svg", href: "", alt: "facebook_logo" },
    {
      src: "/icon-instagram.svg",
      href: "https://www.instagram.com/personalgrowthhacker/",
      alt: "instagram_logo",
    },
    {
      src: "/icon-mail.svg",
      href: "https://www.linkedin.com/company/lovencoders/",
      alt: "linkedin_logo",
    },
    {
      src: "/icon-youtube.svg",
      href: "https://www.youtube.com/channel/UCDkp-KqZH7dPQGbwRYpklhA",
      alt: "youtube_logo",
    },
  ];
  return (
    <div id="reach-us-container">
      <div>
        <div id="reach-us-title">Other Ways to Reach Us</div>
      </div>

      <div className="contact-reach-container">
        <div className="contact-reach-innercontainer">
          <div className="contact-reach-contact">
            <div className="contact-reach-title">Email</div>
            <div>
              <div className="contact-reach-desc">
                {/* <a
                  href="mailto:support@lovencoders.com"
                  className="contact-link"
                >
                  support@lovencoders.com
                </a> */}
              </div>
              <div className="contact-reach-desc mt-1">
                <a href="mailto:lovencoders@gmail.com" className="contact-link">
                lovencode@gmail.com
                </a>
              </div>
            </div>
          </div>
          <div className="contact-reach-contact">
            <div className="contact-reach-title">Contact</div>
            <div>
              <div className="contact-reach-desc">+91 997 557 0015</div>
              <div className="contact-reach-desc mt-1">+91 8484 000 268</div>
            </div>
          </div>
        </div>
        <div className="contact-reach-innercontainer social-media">
          <div className="contact-reach-title">Social Media</div>
          <div className="contact-reach-social-container">
            {socialLinks.map((link, index) => (
              <a href={link.href} target="_blank" key={index} rel="noreferrer">
                <img src={link.src} alt={link.alt} className="h-social" />
              </a>
            ))}
          </div>
        </div>
        <div className="contact-reach-innercontainer">
          <div className="contact-reach-title">Visit Us</div>
          <div className="contact-reach-desc">
            We’re based in Pune-India, but our reach is global. 
          </div>
          <div>
            <div className="contact-reach-title">Office Address</div>
            <div className="contact-reach-desc address">
            C-703, Ganesham Phase 1, Pimple Saudagar, Pune - 411027
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReachUs;
